import axios from "axios";
import { toast } from "react-toastify";

export const createPromoCode = async (payload) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "admin/promo",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      },
    );
    toast.success(response?.data?.message);
    return response;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      toast.error(err?.response?.data?.message);
      console.log(err?.response?.data?.message);
      return err?.response?.data?.message;
    }
  }
};
export const getPromoCode = async (payload) => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `admin/promos?page=${payload?.currentPage}&perPage=${
          payload?.perPage
        }&keyword=${payload?.filterText ?? ""}&userType=${payload?.userType}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      },
    );
    return response?.data;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      toast.error(err?.response?.data?.message);
      console.log(err?.response?.data?.message);
      return err?.response?.data?.message;
    }
  }
};
export const deletePromoCode = async (payload) => {
  try {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL + `admin/promo/${payload}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      },
    );
    return response?.data;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      toast.error(err?.response?.data?.message);
      return err?.response?.data?.message;
    }
  }
};
export const viewPromoCode = async (payload) => {
  console.log(payload, "Pa");
  try {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `admin/promo/${payload}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      },
    );
    return response?.data;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      toast.error(err?.response?.data?.message);
      return err?.response?.data?.message;
    }
  }
};
export const editPromoCode = async (payload) => {
  try {
    const response = await axios.put(
      process.env.REACT_APP_API_URL + `admin/promo/${payload?.id}`,
      payload?.payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      },
    );
    toast.success(response?.data?.message);
    return response;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      toast.error(err?.response?.data?.message);
      console.log(err?.response?.data?.message);
      return err?.response?.data?.message;
    }
  }
};
